/**
 * `labor.device_session.page` wire values for Assembly (queue vs work-order job).
 */

/** Queue route — not a clocked-in work surface. */
export const ASSEMBLY_LIST_LABOR_PAGE = "assembly";

const ASSEMBLY_JOB_PREFIX = "assembly-job:";

export function assemblyLaborPageKeyForWorkOrder(buildOrderId: number): string {
  return `${ASSEMBLY_JOB_PREFIX}${buildOrderId}`;
}

export function assemblyLaborExpectedPageFromPathname(pathname: string): string {
  const match = pathname.match(/^\/manufacturing\/assembly\/work-orders\/(\d+)/);
  if (match) {
    const buildOrderId = Number.parseInt(match[1] ?? "", 10);
    if (Number.isFinite(buildOrderId) && buildOrderId > 0) {
      return assemblyLaborPageKeyForWorkOrder(buildOrderId);
    }
  }
  if (pathname.startsWith("/manufacturing/assembly")) {
    return ASSEMBLY_LIST_LABOR_PAGE;
  }
  return ASSEMBLY_LIST_LABOR_PAGE;
}
